import { Component, Vue, Ref } from "vue-property-decorator";
import AddNew from './components/AddNew.vue'
import Edit from './components/Edit.vue'
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
const slsp = new SupplierServiceProxy()
@Component({
  components: {
    AddNew,
    Edit
  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_action'),
        dataIndex: 'id',
        key: 'id',
        width: 80,
        customRender: (sort, _record, index) => {
          return (
            _record.id &&
            <a class="table-span" onClick={() =>this.editRecord(_record)}> { this.$t('edit') } </a>
          )
        },
      },
      {
        title: this.$t('page_material_supplier_code'),
        dataIndex: 'code',
        key: 'code',
        width:200,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_supplier_name'),
        dataIndex: 'name',
        key: 'name',
        width:250,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_supplier_address'),
        dataIndex: 'address',
        key: 'address',
        width:250,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_tel'),
        dataIndex: 'tel',
        key: 'tel',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '1',
        dataIndex: 'extend1',
        key: 'extend1',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '2',
        dataIndex: 'extend2',
        key: 'extend2',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '3',
        dataIndex: 'extend3',
        key: 'extend3',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '4',
        dataIndex: 'extend4',
        key: 'extend4',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_more') + '5',
        dataIndex: 'extend5',
        key: 'extend5',
        width:150,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      }
    ]
  };
  data = []
  cacheData = []
  selectedRowKeys = []
  addNewVisible = false
  editVisible = false
  item = {}
  searchKey = ""
  pagination = {
    showQuickJumper: true,
    showSizeChanger: true,
    total: 0,
    pageSize: 30,
    current: 1
  }
  scrollY = 1080
  printVisible = false
  dataList = []

  mounted() {
    this.$nextTick(() => {
      this.getList()
    })
  }

  updated(){
    this.$nextTick(() => {
      const div = document.getElementById('black-main')
      this.scrollY = div ? div.clientHeight - 100 : 500
    })
  }

  getList(){
    this.data = []
    slsp.getPageSupplier(this.pagination.current,this.searchKey,this.pagination.pageSize).then(res =>{
      this.pagination.total = Number(res.total)
      this.pagination.current = Number(res.current)
      this.pagination.pageSize = Number(res.size)
      // this.data = res.records

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }
      this.data = JSON.parse(JSON.stringify(copy));

    })
  }

  reload(){
    this.editVisible = false
    this.addNewVisible = false
    this.pagination.current = 1
    this.getList()
  }

  onSelectChange(selectedRowKeys) {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.selectedRowKeys = selectedRowKeys;
  }
  
  addNew(){
    this.addNewVisible = true
  }
  
  delete(){
    slsp.deleteSupplier(this.selectedRowKeys).then(() =>{
      this.pagination.current = 1
      this.$message.success(this.$t('delete_success'))
      this.selectedRowKeys = []
      this.getList()
    })
  }

  onSearch(value) {
    this.pagination.current = 1
    this.searchKey = value
    this.getList()
  }

  addClose(){
    this.addNewVisible = false
  }

  editRecord(value){
    this.item = value
    console.log(value)
    this.editVisible = true
  }

  editClose(){
    this.editVisible = false
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    Object.assign(this.pagination, pager)
    this.getList()
  }
  
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.data.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  printing() {
    this.getData()
    this.printVisible = true
    
  }
  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.id ? false : true
      }
    })
  }

  cancelChooseArr(val) {
    this.selectedRowKeys = [];
  }

  render() {
    return (
      <blank-view>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_material_add_supplier') }</a-button>
            <a-popconfirm title={ this.$t('delete_tips')} onConfirm={() => this.delete()}>
              <a-button type="danger" disabled={this.selectedRowKeys.length === 0}>{ this.$t('delete') }</a-button>
            </a-popconfirm>
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-left: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner">
          <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            row-key="id"
            scroll={this.scrollY ? { y: this.scrollY, x: 1680 } : { x: 1680 }}
            row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange,getCheckboxProps: this.getCheckboxProps }}
            chooseArr={this.selectedRowKeys}
            onCancelChooseArr={this.cancelChooseArr}
          >
          </ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            show-total={total => `${ this.showTotal(total) }`}
            current={this.pagination.current}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}

            on-change={this.handleTableChange}
            on-showSizeChange={this.handleTableChange}
          />
          <Edit visible={this.editVisible} item={this.item} onClose={() => this.editClose()} onReload={() => this.reload()}></Edit>
        </div>
        <add-new visible={this.addNewVisible} onClose={() => this.addClose()} onRel={() => this.reload()}></add-new>
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </blank-view>
    )
  }
}
